export * from './src/contacts-v4-attachment-attachments.universal.js';
